import { Link } from "react-router-dom";
import { ArrowRight, Leaf } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_601a1bdb-08a6-434f-af56-e7b6fec3d8d2/artifacts/yh4f7a3m_7279015-uhd_4096_2160_24fps.mp4";

export default function HeroVideo() {
  return (
    <section
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] overflow-hidden flex items-center bg-[var(--cc-bg)]"
    >
      <video
        data-testid="hero-video"
        className="cc-hero-video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src={VIDEO_URL} type="video/mp4" />
      </video>

      {/* Cream overlay + side wash for legibility (no dark backgrounds) */}
      <div className="absolute inset-0 bg-[var(--cc-bg)]/70 md:bg-[var(--cc-bg)]/55" />
      <div className="absolute inset-0 bg-gradient-to-r from-[var(--cc-bg)] via-[var(--cc-bg)]/90 to-[var(--cc-bg)]/70 md:via-[var(--cc-bg)]/85 md:to-[var(--cc-bg)]/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--cc-bg)]/40 via-transparent to-[var(--cc-bg)]" />

      <div className="relative z-10 cc-container py-32 md:py-40">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full bg-white/75 backdrop-blur-md border border-[var(--cc-line)] text-xs tracking-[0.18em] uppercase text-[var(--cc-text-soft)]">
            <Leaf size={18} strokeWidth={1.6} className="text-[var(--cc-primary)]" />
            A space to exhale
          </div>

          <h1
            data-testid="hero-headline"
            className="mt-6 font-serif text-5xl sm:text-6xl md:text-7xl leading-[1.05] tracking-tight text-[var(--cc-text)]"
          >
            Support, connection<br />
            &amp; <em className="italic text-[var(--cc-text)]/85">space to grow.</em>
          </h1>

          <p
            data-testid="hero-subtext"
            className="mt-7 text-lg md:text-xl text-[var(--cc-text)] md:text-[var(--cc-text-soft)] max-w-2xl leading-relaxed font-medium md:font-normal"
          >
            A calm, one-on-one space to talk, process, and feel heard — without
            pressure, judgment, or expectations. You don&apos;t have to navigate
            life alone.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link to="/booking" data-testid="hero-cta-primary" className="cc-btn-primary">
              Connect With Me <ArrowRight size={16} strokeWidth={1.7} />
            </Link>
            <Link to="/about" data-testid="hero-cta-secondary" className="cc-btn-secondary">
              Stay a while
            </Link>
          </div>

          <div className="mt-12 flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-[var(--cc-text-soft)]/80">
            <span className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--cc-primary)] cc-breathe" />
              Lived experience
            </span>
            <span className="hidden sm:flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--cc-secondary)] cc-breathe" />
              Judgment-free
            </span>
            <span className="hidden md:flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--cc-accent)] cc-breathe" />
              In-person &amp; virtual
            </span>
          </div>
        </div>
      </div>

      {/* Bottom soft fade to next section */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-[var(--cc-bg)]" />
    </section>
  );
}
